<template lang='pug'>
  i.svg-icon.svg-icon-mic
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M66.92,37.7c0,4.39,0,8.79,0,13.18c0,4.32-1.21,8.24-4.11,11.49c-4.4,4.93-9.93,6.95-16.39,5.47 c-6.8-1.56-11.12-5.93-12.85-12.72c-0.36-1.42-0.46-2.93-0.47-4.4c-0.04-8.76-0.03-17.52-0.02-26.28 c0.01-7.72,4.28-13.9,11.32-16.47c6.76-2.46,14.68-0.09,19,5.67c2.41,3.21,3.5,6.82,3.5,10.79C66.92,28.85,66.92,33.28,66.92,37.7z')
      path(d='M46.95,86.93c0-2.75,0-5.38,0-8.04c-1.43-0.3-2.86-0.52-4.25-0.9c-5.63-1.56-10.32-4.61-14.01-9.15 c-4.04-4.97-6.02-10.7-6.21-17.08c-0.06-1.93,1.15-3.31,2.95-3.38c1.72-0.07,3.02,1.14,3.1,3.03c0.15,3.48,0.8,6.83,2.48,9.9 c3.37,6.16,8.48,9.99,15.43,11.19c6.34,1.09,12.07-0.45,17.05-4.46c4.28-3.45,6.87-7.95,7.68-13.42c0.16-1.1,0.22-2.22,0.31-3.34 c0.14-1.75,1.39-2.94,3.06-2.9c1.7,0.04,3.01,1.33,2.98,3.09c-0.06,4.39-1,8.59-3.03,12.51c-3.02,5.82-7.52,10.08-13.53,12.73 c-2.29,1.01-4.67,1.68-7.15,1.99c-0.58,0.07-0.82,0.22-0.81,0.86c0.04,2.43,0.02,4.85,0.02,7.38c0.38,0,0.68,0,0.98,0 c3.36,0,6.72-0.02,10.07,0.01c2.13,0.02,3.47,1.91,2.87,3.94c-0.39,1.29-1.51,2.1-3,2.1c-4.09,0.01-8.17,0-12.26,0 c-5.23,0-10.47,0.01-15.7-0.01c-2.18-0.01-3.56-1.89-2.95-3.96c0.37-1.27,1.48-2.08,2.91-2.09c3.33-0.02,6.66-0.01,9.99-0.01 C46.26,86.93,46.56,86.93,46.95,86.93z')


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
